import { useQuery } from '@tanstack/react-query';
import getEncompassFieldSchema from 'src/services/encompass/getEncompassFieldSchema';

export const useEncompassFieldSchema = (fieldIds?: string) => {
  return useQuery({
    queryKey: ['/shared/encompass/field-schema', fieldIds],
    queryFn: getEncompassFieldSchema,
    staleTime: 5 * 60 * 1000,
    enabled: true,
  });
};

export default useEncompassFieldSchema;
